/**
 * Tablespace Manager Feature Module
 *
 * Registers the tablespace-manager workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the tablespace-manager workspace component
registerWorkspaceComponent(
  'tablespace-manager',
  lazyWorkspaceTab(() => import('./components/TablespaceManagerTab').then((m) => ({ default: m.TablespaceManagerTab }))),
);

// Re-export components
